import { getProfileApi } from '@/api/auth'

export const userMiddleware = () => (next) => async (action) => {
  if (action.type === 'SET_USER_INFO') {
    try {
      const res = await getProfileApi()
      if (res.code === 0) {
        action.payload = res
        return next(action)
      }
    } catch (error) {
      // 如果发生错误，dispatch 错误 action
      return next({ type: 'SET_ERROR', payload: error.message })
    }
  }
  return next(action)
}